import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.hangzensurfsea.com";

const Seo = ({
  title,
  description,
  path = "/",
  image = "/icon-512.png",
  type = "website",
  service,
  price,
}) => {
  const fullTitle = title.includes("Hang Zen")
    ? title
    : `${title} | Hang Zen Surf + Sea`;
  const url = `${SITE_URL}${path}`;
  const imgUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  // JSON-LD structured data for Service pages
  const serviceJsonLd = service
    ? {
        "@context": "https://schema.org",
        "@type": "Service",
        name: service,
        description,
        provider: {
          "@type": "LocalBusiness",
          name: "Hang Zen Surf + Sea",
          telephone: "+1-760-331-3243",
          email: "hangzensurfschool@gmail.com",
          address: {
            "@type": "PostalAddress",
            streetAddress: "916 Neptune Ave",
            addressLocality: "Encinitas",
            addressRegion: "CA",
            postalCode: "92024",
            addressCountry: "US",
          },
        },
        url,
        ...(price && {
          offers: {
            "@type": "Offer",
            price: price.toString(),
            priceCurrency: "USD",
            url,
          },
        }),
      }
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imgUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Hang Zen Surf + Sea" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imgUrl} />
      {serviceJsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(serviceJsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
